import { navLinks } from "@/mocks/nav";
import { categories } from "@/mocks/categories";
import { events } from "@/mocks/events";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-heading font-bold text-xl">5.1吃瓜</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90 mb-5">
              专注娱乐事件盘点与大瓜合集梳理，按事件热度与时间线整理近期焦点，让你一次看懂热门事件的来龙去脉。
            </p>
            <div className="flex items-center gap-2">
              <a
                href="mailto:hello@51chigua.com"
                aria-label="发送邮件"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line" />
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("contact");
                }}
                aria-label="爆料线索"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-chat-forward-line" />
              </a>
              <button
                type="button"
                aria-label="返回顶部"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-up-line" />
              </button>
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-sm font-medium tracking-widest text-accent-300 mb-4">站点导航</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#top"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  首页
                </a>
              </li>
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.id);
                    }}
                    className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-medium tracking-widest text-accent-300 mb-4">主题分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href="#categories"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo("categories");
                    }}
                    className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium tracking-widest text-accent-300 mb-4">最新盘点</h4>
            <ul className="space-y-3">
              {events.slice(0, 4).map((item) => (
                <li key={item.id}>
                  <a
                    href="#events"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo("events");
                    }}
                    className="block text-sm text-background-200/85 leading-snug hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/80 text-center sm:text-left">
            © {year} 5.1吃瓜 · 内容均为公开信息整理，仅供信息参考与娱乐阅读。
          </p>
          <p className="text-xs text-background-300/80">
            联系邮箱：<a href="mailto:hello@51chigua.com" className="hover:text-accent-300 transition-colors">hello@51chigua.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}